export enum DraggingType {
    NEW_COMPONENT_INSTANCE = 'new_component_instance',
    EXISTING_COMPONENT_INSTANCE = 'existing_component_instance',
    ANCHOR = 'anchor',
    COMMENT = 'comment',
    INFO_BLOCK = 'infoBlock',
    IMAGE = 'image',
    TEXTAREA = 'textarea',
    GROUP = 'group',
    SELECTION = 'selection',
    SNIPPET = 'snippet',
}
